<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span *ngIf="!isPortraitDevice" class="text-headline-title">
            {{ documentationTitle | translate }}
        </span>
        <span class="text-paragraph">
            {{ documentationSubtitle | translate }}
        </span>
    </div>

    <!-- 
    <form class="form" [formGroup]="formGroup">//-FALTA-implementar clase form
     -->
    <form [formGroup]="formGroup">
        <div class="contenedor-documents">
            <div class="contenedor-left">
                <div class="parts">
                    <div class="text-paragraph-title">{{ documentationBank | translate }}</div>
                    <div class="first-line">
                        <div class="image-doc"><i class="ri-file-text-line"></i></div>
                        <div class="feature">
                            <p-fileUpload
                                mode="basic"
                                chooseLabel="{{ docBankBox | translate }}"
                                chooseIcon="pi pi-upload"
                                accept=".pdf, .bmp, .jpg, .jpeg, .gif, .png"
                                name="upload1"
                                maxFileSize="6000000"
                                (onSelect)="onSelect($event)"
                            />
                        </div>
                        <div class="cloud"><i class="ri-upload-cloud-2-line"></i></div>
                    </div>
                    <div class="info">
                        <i class="ri-information-line"></i>
                        <div class="text-paragraph">{{ docBankInfo | translate }}</div>
                    </div>
                </div>

                <div class="parts">
                    <div class="text-paragraph-title">{{ documentationWorth | translate }}</div>
                    <div class="first-line">
                        <div class="image-doc"><i class="ri-file-text-line"></i></div>
                        <div class="feature">
                            <p-fileUpload
                                mode="basic"
                                chooseLabel="{{ docWorthBox | translate }}"
                                chooseIcon="pi pi-upload"
                                accept=".pdf, .bmp, .jpg, .jpeg, .gif, .png"
                                maxFileSize="6000000"
                                (onSelect)="onSelect($event)"
                            />
                        </div>
                        <div class="cloud"><i class="ri-upload-cloud-2-line"></i></div>
                    </div>
                    <div class="info">
                        <i class="ri-information-line"></i>
                        <div class="text-paragraph">{{ docWorthInfo | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="contenedor-right">
                <div class="panel2">
                    <div class="bank-info">{{ docSideSteps | translate }}</div>
                    <progress value="50" max="100"></progress>
                    <div class="step-doc">
                        <i class="ri-check-line"></i>
                        <div class="step">{{ docSideStep1 | translate }}</div>
                    </div>
                    <div class="step-doc">
                        <i class="ri-check-line"></i>
                        <div class="step">{{ docSideStep2 | translate }}</div>
                    </div>
                    <div class="time">
                        <div class="icon"><i class="ri-time-line"></i></div>
                        <div class="text-time">{{ docSideTime | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="actions">
        <button
            *ngIf="!isPortraitDevice"
            pripple=""
            class="button-secondary button-next"
            type="button"
            [disabled]="backButtonDisabled"
            (click)="onClicButtonBack()"
        >
            <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
            <span class="p-button-label-right">{{ backButton | translate }}</span>
        </button>

        <button
            pripple=""
            class="button-primary button-next"
            type="button"
            [disabled]="continueButtonDisabled"
            (click)="onClicButtonContinue()"
            [ngClass]="{ 'is-portrait': isPortraitDevice }"
        >
            <span class="p-button-label-left">{{ continueButton | translate }}</span>
            <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
        </button>
    </div>
</div>
